(function () {
  const SELECTOR = '#cart-drawer';
  const SECTION_ID = 'cart-drawer';

  const drawerEl = document.querySelector(SELECTOR);
  if (!drawerEl) return;

  const getOverlay = () => drawerEl.querySelector('.cart-drawer__overlay, .js-cart-overlay');
  const getCloseBtn = () => drawerEl.querySelector('.js-cart-close');
  const getLoadingEl = () => drawerEl.querySelector('.cart-drawer__loading');

  let animating = false;
  let pendingOpen = false;
  let closeRequested = false;
  let lastHeaderTap = 0;
  let overlayGuardRAF = 0;

  function showLoading(active) {
    const l = getLoadingEl();
    if (!l) return;
    l.classList.toggle('is-active', !!active);
  }

  function enforceOverlayVisibleWhileOpen() {
    cancelAnimationFrame(overlayGuardRAF);
    function tick() {
      if (!document.documentElement.classList.contains('cart-drawer-open')) return;
      const ovl = getOverlay();
      if (ovl) {
        // Remove attributes that can hide it
        if (ovl.hasAttribute('hidden')) ovl.removeAttribute('hidden');
        ovl.style.display = '';
        ovl.style.opacity = '';
        ovl.style.visibility = '';
        // Some themes toggle aria-hidden on overlay; it shouldn't affect visibility, but clear it
        if (ovl.getAttribute('aria-hidden') === 'true') ovl.removeAttribute('aria-hidden');
      }
      overlayGuardRAF = requestAnimationFrame(tick);
    }
    overlayGuardRAF = requestAnimationFrame(tick);
  }

  function stopOverlayGuard() {
    cancelAnimationFrame(overlayGuardRAF);
  }

  function onTransitionEnd(e) {
    const panel = drawerEl.querySelector('.cart-drawer__panel');
    if (!panel || e.target !== panel) return;

    drawerEl.removeEventListener('transitionend', onTransitionEnd);
    animating = false;

    if (!document.documentElement.classList.contains('cart-drawer-open')) {
      endClose();
      if (pendingOpen && !closeRequested) {
        pendingOpen = false;
        openDrawer();
      }
    } else {
      drawerEl.removeAttribute('aria-hidden');
      enforceOverlayVisibleWhileOpen(); // keep overlay forced visible
    }
  }

  function openDrawer() {
    if (closeRequested) return;
    if (animating) { pendingOpen = true; return; }
    animating = true;

    document.documentElement.classList.add('cart-drawer-open');
    drawerEl.removeAttribute('aria-hidden');

    // Do NOT set/remove [hidden] on overlay anymore; CSS + guard will handle it
    enforceOverlayVisibleWhileOpen();

    drawerEl.addEventListener('transitionend', onTransitionEnd);
    setTimeout(() => {
      if (animating) {
        animating = false;
        drawerEl.removeEventListener('transitionend', onTransitionEnd);
        drawerEl.removeAttribute('aria-hidden');
      }
    }, 600);
  }

  function endClose() {
    stopOverlayGuard();
    drawerEl.setAttribute('aria-hidden', 'true');
    closeRequested = false;
  }

  function closeDrawer() {
    if (animating && !closeRequested) {
      closeRequested = true;
      pendingOpen = false;
      return;
    }
    closeRequested = true;
    pendingOpen = false;
    animating = true;

    document.documentElement.classList.remove('cart-drawer-open');

    drawerEl.addEventListener('transitionend', onTransitionEnd);
    setTimeout(() => {
      if (animating) {
        animating = false;
        drawerEl.removeEventListener('transitionend', onTransitionEnd);
        endClose();
      }
    }, 600);
  }

  function getSectionHTML(sectionId) {
    return fetch('?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' }).then((r) => r.text());
  }

  function replaceDrawerFromHTML(html) {
    const wasOpen = document.documentElement.classList.contains('cart-drawer-open');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector(SELECTOR);
    if (!fresh) return;
    drawerEl.innerHTML = fresh.innerHTML;
    bindLineEvents();
    bindFrameEvents();

    // If the drawer is open, immediately enforce overlay visibility after refresh
    if (wasOpen) {
      enforceOverlayVisibleWhileOpen();
    }
  }

  function refreshDrawer(openAfter) {
    return getSectionHTML(SECTION_ID)
      .then(replaceDrawerFromHTML)
      .then(() => { if (openAfter && !closeRequested) openDrawer(); })
      .catch(() => {});
  }

  function changeLine(opts) {
    showLoading(true);
    const body = JSON.stringify({
      id: opts.key,
      quantity: opts.quantity,
      sections: [SECTION_ID],
      sections_url: window.location.pathname
    });
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body
    })
      .then((r) => r.json())
      .then(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        return refreshDrawer(false);
      })
      .finally(() => showLoading(false));
  }

  function setATCLoading(btn, isLoading) {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!isLoading);
    btn.disabled = !!isLoading;
    const txt = btn.dataset.loadingText;
    if (txt) {
      if (isLoading) {
        btn.dataset._origText = btn.textContent;
        btn.textContent = txt;
      } else if (btn.dataset._origText) {
        btn.textContent = btn.dataset._origText;
        delete btn.dataset._origText;
      }
    }
  }

  function addToCart(formEl, btnEl) {
    const formData = new FormData(formEl);
    if (!formData.get('quantity')) formData.set('quantity', '1');

    setATCLoading(btnEl, true);
    showLoading(true);

    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(async (r) => {
        if (!r.ok) throw (await r.json().catch(() => ({})));
        return r.json();
      })
      .then(() => refreshDrawer(false))
      .then(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        openDrawer();
      })
      .catch(() => {
        try { formEl.submit(); } catch (_) {}
      })
      .finally(() => {
        setATCLoading(btnEl, false);
        showLoading(false);
      });
  }

  function bindLineEvents() {
    drawerEl.querySelectorAll('.js-qty-plus').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const key = e.currentTarget.dataset.key;
        const input = drawerEl.querySelector('.cart-drawer__qty-input[data-key="' + CSS.escape(key) + '"]');
        const qty = parseInt((input && input.value) || '0', 10) + 1;
        changeLine({ key, quantity: qty });
      });
    });

    drawerEl.querySelectorAll('.js-qty-minus').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const key = e.currentTarget.dataset.key;
        const input = drawerEl.querySelector('.cart-drawer__qty-input[data-key="' + CSS.escape(key) + '"]');
        const qty = Math.max(0, parseInt((input && input.value) || '0', 10) - 1);
        changeLine({ key, quantity: qty });
      });
    });

    drawerEl.querySelectorAll('.cart-drawer__qty-input').forEach((inp) => {
      inp.addEventListener('change', (e) => {
        const key = e.currentTarget.dataset.key;
        const val = parseInt(e.currentTarget.value || '0', 10);
        const qty = isNaN(val) ? 1 : Math.max(0, val);
        changeLine({ key, quantity: qty });
      });
    });

    drawerEl.querySelectorAll('.js-line-remove').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const key = e.currentTarget.dataset.key;
        changeLine({ key, quantity: 0 });
      });
    });
  }

  function bindFrameEvents() {
    const ovl = getOverlay();
    const xBtn = getCloseBtn();
    if (ovl) ovl.addEventListener('click', (e) => { e.stopPropagation(); if (!animating) closeDrawer(); }, { passive: true });
    if (xBtn) xBtn.addEventListener('click', (e) => { e.preventDefault(); if (!animating) closeDrawer(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !animating) closeDrawer(); });
  }

  function hookHeaderIcon() {
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.js-open-cart');
      if (!trigger) return;
      e.preventDefault();
      const now = Date.now();
      if (now - lastHeaderTap < 300) return;
      lastHeaderTap = now;

      if (!animating && !closeRequested) {
        openDrawer();
        refreshDrawer(false).then(() => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh')));
      }
    });
  }

  function hookAddToCartOpen() {
    const openOnAdd = drawerEl.dataset.openOnAdd === 'true';
    if (!openOnAdd) return;

    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      const btn = form.querySelector('button[name="add"], .mp__add');
      e.preventDefault();
      addToCart(form, btn);
    });
  }

  // Public API
  window.ShopifyCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: function () { return refreshDrawer(true); }
  };

  // Init
  bindLineEvents();
  bindFrameEvents();
  hookHeaderIcon();
  hookAddToCartOpen();
})();
